var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-row", { staticClass: "slider-container" }, [
    _c("div", { staticClass: "theme-slider-main" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("panel.dashboard_theme")) + "\n  "),
    ]),
    _c("div", { staticClass: "theme-slider-position" }),
    _c(
      "div",
      [
        _vm.sliderShow
          ? _c("slider", { on: { reload: _vm.sliderReload } })
          : _vm._e(),
      ],
      1
    ),
    _vm.collapseShow
      ? _c("div", { staticStyle: { margin: "12px", "overflow-y": "auto" } }, [
          _c(
            "div",
            [
              _c(
                "el-collapse",
                {
                  on: { change: _vm.handleChange },
                  model: {
                    value: _vm.activeNames,
                    callback: function ($$v) {
                      _vm.activeNames = $$v
                    },
                    expression: "activeNames",
                  },
                },
                [
                  _c(
                    "el-collapse-item",
                    {
                      attrs: {
                        title: _vm.$t("panel.overall_setting"),
                        name: "panel",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        { staticClass: "selector-div" },
                        [_c("overall-setting")],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-collapse-item",
                    {
                      attrs: {
                        title: _vm.$t("panel.panel_background"),
                        name: "panelBackground",
                      },
                    },
                    [_c("background-selector")],
                    1
                  ),
                  _c(
                    "el-collapse-item",
                    {
                      attrs: {
                        title: _vm.$t("panel.view_style"),
                        name: "componentStyle",
                      },
                    },
                    [_c("background-overall")],
                    1
                  ),
                  _c(
                    "el-collapse-item",
                    {
                      attrs: {
                        title: _vm.$t("panel.view_color_setting"),
                        name: "graphical",
                      },
                    },
                    [
                      _c("panel-color-selector", {
                        on: { onColorChange: _vm.onColorChange },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-collapse-item",
                    {
                      attrs: {
                        title: _vm.$t("panel.chart_title"),
                        name: "table",
                      },
                    },
                    [
                      _c("view-title", {
                        on: { onTextChange: _vm.onTextChange },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-collapse-item",
                    {
                      attrs: {
                        title: _vm.$t("panel.filter_component"),
                        name: "filterComponent",
                      },
                    },
                    [_c("FilterStyleSelector")],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }